import { axiosInstance as axios } from "services";

export const fetchAutoText = async (statementId) => {
  const { data } = await axios.get(`/admin/proposalText/autoText?category=${statementId}`);
  if (!data.success) throw new Error(data.error || "Failed to fetch auto text");
  return data;
};

